import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, Megaphone, MessageCircleMore } from "lucide-react";
import { useTranslation } from "react-i18next";
import Sidebar from "./Sidebar";
import AppFooter from "../Common/AppFooter";
import KorresLogo from "../Common/KorresLogo";

// TEMPORARY — hides the announcement bar across all pages. Flip back to
// true to restore it.
const SHOW_ANNOUNCEMENT_BANNER = false;

const Layout = ({ children, activeLabel = "Home" }) => {
    const { t } = useTranslation();
    const location = useLocation();
    const [isMobileOpen, setIsMobileOpen] = useState(false);
    const showChatLauncher = location.pathname === "/dashboard";
    const isAuraPage = location.pathname === "/aura-ai-assistant";

    return (
        <div className="min-h-screen bg-white text-slate-900">
            <Sidebar
                activeLabel={activeLabel}
                isMobileOpen={isMobileOpen}
                onClose={() => setIsMobileOpen(false)}
            />
            <div className="mx-auto flex min-h-screen w-full flex-col md:pl-72">
                <div className="sticky top-0 z-30 flex items-center gap-3 border-b border-slate-200 bg-white/95 px-6 py-4 backdrop-blur md:hidden">
                    <button
                        type="button"
                        onClick={() => setIsMobileOpen(true)}
                        className="flex h-10 w-10 items-center justify-center rounded-full text-slate-700 transition hover:bg-slate-100 focus:outline-none"
                        aria-label="Open menu"
                    >
                        <Menu className="h-6 w-6" />
                    </button>
                    <KorresLogo />
                </div>
                <main className={`flex-1 ${isAuraPage ? "p-0" : "px-6 py-8 lg:px-10"}`}>
                    {!isAuraPage && SHOW_ANNOUNCEMENT_BANNER ? <div className="mb-4 flex justify-center">
                        <div className="inline-flex items-center gap-3 rounded-xl bg-amber-50 border border-amber-200 px-4 py-3">
                            <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-amber-200">
                                <Megaphone className="h-4 w-4 text-amber-700" />
                            </div>
                            <p className="text-sm text-amber-800 leading-relaxed font-bold">{t("DASHBOARD_ANNOUNCEMENT_DELAY")}</p>
                        </div>
                    </div> : null}
                    {children}
                </main>
                {showChatLauncher ? (
                    <Link
                        to="/messages"
                        className="fixed bottom-4 right-4 z-40 inline-flex items-center gap-2 rounded-full bg-primary px-4 py-3 text-sm font-semibold text-white shadow-[0_14px_35px_rgba(15,27,143,0.28)] transition hover:scale-[1.02] hover:bg-[#0b1673] focus:outline-none md:bottom-6 md:right-6 md:px-5"
                        aria-label={t("HELP_CHAT_NEW_CHAT")}
                    >
                        <MessageCircleMore className="h-5 w-5" />
                        <span className="hidden md:inline">{t("HELP_CHAT_NEW_CHAT")}</span>
                    </Link>
                ) : null}
                {!isAuraPage ? <AppFooter /> : null}
            </div>
        </div>
    );
};

export default Layout;
